/*
  Atlanticus — <cart-drawer-upsell> web component.

  Renders nothing itself (markup comes from snippets/cart-drawer-upsell.liquid,
  server-rendered inside the cart-drawer section). On an 'Ekle' click it POSTs the
  variant to /cart/add.js requesting fresh 'cart-drawer' + 'cart-icon-bubble'
  sections, then hands the response to <cart-drawer>.renderContents() so the
  subtotal, taksit row, item count, free-shipping progress AND this upsell button
  all recalc server-side in one shot.

  Mirrors the addToCart() pattern in assets/castra-customizer.js.

  Note: because renderContents() replaces the entire #CartDrawer subtree, this
  element is destroyed and a fresh one is connected after each add — so we bind in
  connectedCallback and never need to re-bind manually.
*/
(function () {
  'use strict';

  class CartDrawerUpsell extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.addEventListener('click', this._onClick.bind(this));
    }

    _onClick(event) {
      var btn = event.target.closest('[data-upsell-add]');
      if (!btn || !this.contains(btn)) return;
      if (btn.disabled || btn.classList.contains('is-added')) return;

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      this._add(variantId, btn);
    }

    _add(variantId, btn) {
      var self = this;

      btn.disabled = true;
      btn.classList.add('is-loading');
      var prevLabel = btn.textContent;
      btn.textContent = 'Ekleniyor…';

      var body = {
        id: variantId,
        quantity: 1,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      };

      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) {
          return r.json().then(function (d) {
            return { ok: r.ok, data: d };
          });
        })
        .then(function (res) {
          if (!res.ok) {
            throw new Error(res.data.description || res.data.message || 'Ürün eklenemedi.');
          }

          // Flip the button immediately for snappy feedback; the drawer re-render
          // below replaces this whole node anyway (with is-added baked in server-side).
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          btn.textContent = 'Eklendi ✓';

          var drawer = document.querySelector('cart-drawer');
          if (drawer && res.data.sections && typeof drawer.renderContents === 'function') {
            try {
              drawer.renderContents(res.data);
              return;
            } catch (e) {
              /* fall through to reload */
            }
          }
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        })
        .catch(function (err) {
          btn.classList.remove('is-loading');
          btn.disabled = false;
          btn.textContent = prevLabel;
          var errBox = document.getElementById('CartDrawer-CartErrors');
          if (errBox) errBox.textContent = err.message;
        });
    }
  }

  if (!customElements.get('cart-drawer-upsell')) {
    customElements.define('cart-drawer-upsell', CartDrawerUpsell);
  }
})();
